// chick icons
import c0 from '../../shared/assets/icons/chick/0.png';
import c1 from '../../shared/assets/icons/chick/1.png';
import c2 from '../../shared/assets/icons/chick/2.png';
import c3 from '../../shared/assets/icons/chick/3.png';
import c4 from '../../shared/assets/icons/chick/4.png';
import c5 from '../../shared/assets/icons/chick/5.png';
import c6 from '../../shared/assets/icons/chick/6.png';
import c7 from '../../shared/assets/icons/chick/7.png';
// pizza icons
import p0 from '../../shared/assets/icons/pizza/0.svg';
import p1 from '../../shared/assets/icons/pizza/1.svg';
import p2 from '../../shared/assets/icons/pizza/2.svg';
import p3 from '../../shared/assets/icons/pizza/3.svg';
import p4 from '../../shared/assets/icons/pizza/4.svg';
import p5 from '../../shared/assets/icons/pizza/5.svg';
import p6 from '../../shared/assets/icons/pizza/6.svg';
import p7 from '../../shared/assets/icons/pizza/7.svg';
// apple icons
import a0 from '../../shared/assets/icons/apple/0.png';
import a1 from '../../shared/assets/icons/apple/1.png';
import a2 from '../../shared/assets/icons/apple/2.png';
import a3 from '../../shared/assets/icons/apple/3.png';
import a4 from '../../shared/assets/icons/apple/4.png';
import a5 from '../../shared/assets/icons/apple/5.png';
import a6 from '../../shared/assets/icons/apple/6.png';
import a7 from '../../shared/assets/icons/apple/7.png';
// match icons
import m0 from '../../shared/assets/icons/match/0.svg';
import m1 from '../../shared/assets/icons/match/1.svg';
import m2 from '../../shared/assets/icons/match/2.svg';
import m3 from '../../shared/assets/icons/match/3.svg';
import m4 from '../../shared/assets/icons/match/4.svg';
import m5 from '../../shared/assets/icons/match/5.svg';
import m6 from '../../shared/assets/icons/match/6.svg';
import m7 from '../../shared/assets/icons/match/7.svg';

export const loadIcons = (i) => {
    let levels = {
        1: loadChick,
        2: loadApple,
        3: loadMatch,
        4: loadPizza,
    }

    let icons = levels[i]();
    return icons;
}

const loadChick = () => {
    let correctOrder = [c0,c1,c2,c3,c4,c5,c6,c7];
    let startOrder = [c0,c1,c7,c3,c4,c2,c6,c5];
    // let correctOrder = [c0,c1,c6,c7,c5,c3,c2,c4];
    // let startOrder = [c7,c1,c6,c0,c5,c3,c2,c4];

    let icons = {
      'correctOrder': correctOrder,
      'startOrder': startOrder,
      'numIcons': startOrder.length,
    };
    return icons;
};

const loadPizza = () => {
    let correctOrder = [p0,p1,p2,p3,p4,p5,p6,p7];
    let startOrder = [p7,p1,p6,p0,p5,p3,p2,p4];

    let icons = {
      'correctOrder': correctOrder,
      'startOrder': startOrder,
      'numIcons': startOrder.length,
    };
    return icons;
};

const loadApple = () => {
    let correctOrder = [a0,a1,a2,a3,a4,a5,a6,a7];
    let startOrder = [a5,a1,a7,a6,a4,a2,a3,a0];

    let icons = {
      'correctOrder': correctOrder,
      'startOrder': startOrder,
      'numIcons': startOrder.length,
    };
    return icons;
};

const loadMatch = () => {
    let correctOrder = [m0,m1,m2,m3,m4,m5,m6,m7];
    let startOrder = [m2,m6,m4,m3,m1,m0,m7,m5];

    let icons = {
      'correctOrder': correctOrder,
      'startOrder': startOrder,
      'numIcons': startOrder.length,
    };
    return icons;
};